// extracted by mini-css-extract-plugin
export var actionButton = "_wk-2";
export var card = "_wk-0";
export var disambiguationList = "_wk-3";
export var errorCard = "_wk-4";
export var row = "_wk-1";